import {
  IListColumn,
  IListElementCell,
  TIndent,
} from 'app/services/api5-service/api.interface';

import { ISPFormState } from 'common/dynamic-form/model';
import { getFontSize } from 'common/dynamic-form/utils/get-font-size';
import { getFontWeight } from 'common/dynamic-form/utils/get-font-weight';
import { DocHelper } from 'utils/dochelper';

import { IListCellUi } from '../../list-cell/model';
import { StructData, StructElementUi } from '../../struct/model';

/**
 * Get indent size
 *
 * @param indent
 */
function getIndentForStruct(indent: TIndent): string {
  switch (indent) {
    case 'small':
      return '4px';
    case 'medium':
      return '8px';
    case 'large':
      return '12px';
    case 'extra_large':
      return '16px';
  }
}

/**
 * Get price cell with specific data
 *
 * @param cell - FE cell base metadata
 * @param column
 * @param state
 * @param cellData - BE data for cell
 */
export function getStructCellWithData(
  cell: IListCellUi,
  column: IListColumn,
  state: ISPFormState,
  cellData: IListElementCell,
): IListCellUi {
  if (column.$type !== 'struct') {
    return cell;
  }
  const elems = DocHelper.getArrayWrapperValue(column.elem);
  cell.structData = elems.reduce<StructData>(
    (struct, columnElem) => {
      const data: StructElementUi = {
        msg: '',
        color:
          cellData[columnElem.$name]?.$color ||
          cellData.$color ||
          columnElem.$color ||
          cell.color,
        ellipsis:
          cellData[columnElem.$name]?.$ellipsis === 'yes' ||
          columnElem.$ellipsis === 'yes' ||
          cell.ellipsis,
        size:
          getFontSize(
            cellData[columnElem.$name]?.$size ||
              cellData.$size ||
              columnElem.$size,
          ) || cell.size,
        weight:
          getFontWeight(
            cellData[columnElem.$name]?.$weight ||
              cellData.$weight ||
              columnElem.$weight,
          ) || cell.weight,
      };
      switch (columnElem.$type) {
        case 'msg':
          data.msg = DocHelper.getMessage(
            `${column.$name}_${columnElem.$name}`,
            state.docSubject.value,
          );
          break;
        case 'hint':
          // need append hintIcon in cell
          cell.hintIcon = cellData[columnElem.$name]?.$;
          break;
        case 'link':
          data.msg = cellData[columnElem.$name]?.$;
          data.link = cellData[columnElem.$name]
            ? {
                href: cellData[columnElem.$name].$href,
                newTab: cellData[columnElem.$name].$newtab === 'yes',
                internal: cellData[columnElem.$name].$internal === 'yes',
                sameTab: cellData[columnElem.$name].$sametab === 'yes',
                target: cellData[columnElem.$name].$target,
              }
            : undefined;
          break;
        default:
          data.msg = cellData[columnElem.$name]?.$;
      }

      if (data.msg) {
        if (struct[columnElem.$type]) {
          struct[columnElem.$type].push(data);
        } else {
          struct[columnElem.$type] = [data];
        }
      }

      return struct;
    },
    {
      indent: getIndentForStruct(column.$indent || 'medium'),
    } as StructData,
  );

  cell.trackBy = Object.keys(cell.structData)
    .map(key => (cell.structData![key] as StructElementUi).msg)
    .join('');
  cell.verticalAlign = cell.verticalAlign || 'top';

  return cell;
}
